import { useTranslation } from 'react-i18next';
import './HowItWorks.css';

const steps = [
  { num: 1, key: 'step1' },
  { num: 2, key: 'step2' },
  { num: 3, key: 'step3' },
] as const;

export default function HowItWorks() {
  const { t } = useTranslation();

  return (
    <section className="how-section">
      <div className="how-container">
        <span className="section-label">{t('home.landing.howLabel')}</span>
        <h2 className="section-title">{t('home.landing.howTitle')}</h2>

        <div className="how-steps">
          {steps.map(({ num, key }, i) => (
            <div className="how-step" key={key}>
              <div className="step-circle">{num}</div>
              {i < steps.length - 1 && <div className="step-connector" />}
              <h3 className="step-title">{t(`home.landing.${key}Title`)}</h3>
              <p className="step-desc">{t(`home.landing.${key}Desc`)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
